export const REDEEM_MONEY_START = 'REDEEM_MONEY_START';
export const REDEEM_MONEY_SUCCESS = 'REDEEM_MONEY_SUCCESS';
export const REDEEM_MONEY_ERROR = 'REDEEM_MONEY_ERROR';
export const REDEEM_MONEY_END = 'REDEEM_MONEY_END';
export const CLEAR_REDEEM_MONEY_STORE = 'CCLEAR_REDEEM_MONEY_STORE';
